export const formatColorArrayToRGBAString = (values: ReadonlyArray<number>, alphaOverride?: number) => {
  const rgbArray: (string | number)[] = values.slice(0, 3);
  const alpha: number = alphaOverride !== undefined ? alphaOverride : values[3] !== undefined ? values[3] : 1;
  rgbArray.push(alpha);
  return `rgba(${rgbArray.join(', ')})`;
};
